import axios from 'axios';
import Cookies from 'js-cookie';

import { Util } from '../common/util/util';

function get_valid_phone_or_email(phone_or_email: any) {
  if (Util.isEmail(phone_or_email)) {
    return phone_or_email;
  } else {
    return Util.convertPhoneNumber(phone_or_email);
  }
}
export const RegisterApi = () => ({
  //Получить пароль(код)
  //Регистрация пользователя
  async getRegister(phone_or_email: string) {
    const { data } = await axios({
      method: 'post',
      baseURL: process.env.REACT_APP_BASE_URL_API,
      url: '/api/admin/users',
      headers: {
        token: Util.getTokenSecurity(),
      },
      data: {
        phone_or_email: get_valid_phone_or_email(phone_or_email),
        action: 'register_user_with_temp_pwd',
      },
    });
    return data;
  },
  //Получить пароль(код)
  //Регистрация пользователя
  async getRegisterEmail(phone_or_email: string) {
    const { data } = await axios({
      method: 'post',
      baseURL: process.env.REACT_APP_BASE_URL_API,
      url: '/api/admin/users',
      headers: {
        token: Util.getTokenSecurity(),
      },
      data: {
        phone_or_email: get_valid_phone_or_email(phone_or_email),
        action: 'send_user_temp_pwd',
      },
    });
    return data;
  },
  //Получить пароль(код)
  //Вход
  async getSessionByLogin(
    phone_or_email: string,
    pwd: string,
    is_one_time_password: boolean,
    sessionToken?: string
  ) {
    const { data } = await axios({
      method: 'post',
      baseURL: process.env.REACT_APP_BASE_URL_API,
      url: '/api/admin/login',
      headers: {
        token: Util.getTokenSecurity(),
      },
      data: {
        phone_or_email: get_valid_phone_or_email(phone_or_email),
        password: pwd,
        is_one_time_password: is_one_time_password,
      },
    });

    return data;
  },
  async getUserPassword(pwd: string, sessionToken: string) {
    const { data } = await axios({
      method: 'post',
      baseURL: process.env.REACT_APP_BASE_URL_API,
      url: `/api/admin/users`,
      headers: {
        'session-token': sessionToken,
        token: Util.getTokenSecurity(),
      },
      data: {
        action: 'change_user_pwd',
        new_pwd: pwd,
      },
    });
    return data;
  },
  async getCheckLogin(sessionToken: string) {
    const sessionsToken = localStorage.getItem('st');
    const { data } = await axios({
      method: 'post',
      baseURL: process.env.REACT_APP_BASE_URL_API,
      url: '/api/admin/check-login',
      headers: {
        'session-token': String(sessionsToken),
        token: Util.getTokenSecurity(),
      },
    });
    return data;
  },
  async setLogout(sessionToken: string) {
    const { data } = await axios({
      method: 'post',
      baseURL: process.env.REACT_APP_BASE_URL_API,
      url: '/api/admin/logout',
      headers: {
        'session-token': sessionToken,
        token: Util.getTokenSecurity(),
      },
    });
    //Убираем токен сессии и телефон/email в localstorage

    return data;
  },
});
